import Bugsnag from '@bugsnag/js'
import { Close } from '@mui/icons-material'
import { Box, Typography } from '@mui/material'
import AdxFormModal from 'components/reusable/modal/AdxFormModal'
import { Form, Formik } from 'formik'
import React, { useRef } from 'react'
import { useMutation } from 'react-query'
import { useLocation, useNavigate } from 'react-router-dom'
import { uploadEmployeeDetails } from 'services/api/modules/payroll/payroll-config/bulkImportApi'
import { handleValidationErrors } from 'services/helper/handleValidationErrors'
import ImportPayrollDataForm from './ImportPayrollDataForm'

const ImportPayrollData = ({ state }) => {
  const formikRef = useRef()

  const navigate = useNavigate()
  const location = state.backgroundLocation

  const handleCloseModal = (event, reason) => {
    if (reason && reason === 'backdropClick') {
      return
    }
    navigate(-1)
  }

  const mutation = useMutation(uploadEmployeeDetails, {
    onSuccess: (response) => {
      navigate('/app/management-centre/company-management/payroll/import-payroll/import', {
        state: {
          backgroundLocation: location,
          staffData: response.data,
        },
      })
    },
    onError: (error) => {
      if (error.status === 422) {
        if (error.data?.errors) {
          handleValidationErrors(error, formikRef)
        } else {
          let errors = {
            file: [error.data.message],
          }
          let newError = {
            data: {
              errors,
            },
          }
          handleValidationErrors(newError, formikRef)
        }
      } else {
        Bugsnag.notify(error.data)
        let errors = {
          file: [error.data.message],
        }
        let newError = {
          data: {
            errors,
          },
        }
        handleValidationErrors(newError, formikRef)
      }
    },
  })

  const handleUploadImport = async (values) => {
    let newData = values.file[0]
    let formData = new FormData()
    formData.append('file', newData)
    mutation.mutate(formData)
  }

  const CustomHeader = () => {
    return (
      <>
        <Box
          sx={{
            py: 2,
            px: 4,
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: 1,
          }}
        >
          <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <Typography variant="h4">Import payroll details</Typography>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '10%' }}></Box>
          <Close onClick={handleCloseModal} sx={{ cursor: 'pointer' }} />
          {/* <CloseWarning /> */}
        </Box>
      </>
    )
  }

  return (
    <AdxFormModal
      open={true}
      onClose={handleCloseModal}
      handleClose={handleCloseModal}
      title={'Import payroll details'}
    >
      <Formik
        enableReinitialize
        initialValues={{
          file: null,
        }}
        onSubmit={handleUploadImport}
        innerRef={formikRef}
      >
        {(formikProps) => {
          return (
            <Form>
              <ImportPayrollDataForm formikProps={formikProps} />
            </Form>
          )
        }}
      </Formik>
    </AdxFormModal>
  )
}

export default ImportPayrollData
